<template>
    <div class="aba-cliente">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <!-- CAIXA DE BUSCA -->
                <div
                    class="column"
                    :class="[
                        permissaoVincularECadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-area-interesse"
                    />
                </div>

                <!-- SELEÇÃO DE SITUAÇÃO -->
                <div
                    class="column situacao-select"
                    :class="[
                        permissaoVincularECadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <label v-text="$t('situacao')" />
                    <v-select
                        :id="generateId(10)"
                        ref="situacaoInput"
                        class="is-100"
                        label="label"
                        :options="situacoes"
                        @input="onSituacaoChanged"
                        v-model="situacao"
                    >
                        <template slot="option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="no-options">{{ $t('sem-resultados') }}</template>
                    </v-select>
                </div>

                <!-- BOTÃO DE VÍNCULO -->
                <div
                    class="column is-3"
                    v-if="!assAreaInteresseClienteIntegracao && permissao.create"
                >
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalAreaInteresseNaoAssociados"
                    >
                        {{ $t('vincular-area-interesse') }}
                    </button>
                </div>

                <!-- BOTÃO DE CADASTRO -->
                <div
                    class="column is-3"
                    v-if="!areaInteresseIntegracao && permissaoCadastroAreaInteresse.create"
                >
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'cli-areainteresse-new',
                                query: {
                                    tela: 'cliente-areainteresse',
                                    id: $route.params.id,
                                    dadoscadastrais: 10,
                                    politicacomercial: $route.query.politicacomercial
                                        ? $route.query.politicacomercial
                                        : null,
                                    analisecomercial: $route.query.analisecomercial
                                        ? $route.query.analisecomercial
                                        : null,
                                    contexto: isVenda ? 'ven' : 'agro',
                                },
                            })
                        "
                    >
                        {{ $t('adicionar-area-interesse') }}
                    </button>
                </div>
            </div>

            <!-- LISTAGEM -->
            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assareainteressecliente"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <!-- COLUNA DE DESATIVAÇÃO/REATIVAÇÃO -->
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !assAreaInteresseClienteIntegracao"
                                class="action-button"
                                :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                @click="promptChangeSituacao(props.row)"
                                v-tippy
                                :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                            />
                        </div>

                        <!-- COLUNA DE SITUAÇÃO -->
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row['situacao'] == 1"
                                type="is-success"
                                size="is-medium"
                                >{{ $t('ativo') }}</b-tag
                            >
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                                >{{ $t('inativo') }}</b-tag
                            >
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>

                <!-- PAGINAÇÃO -->
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <AreaInteresseModal :idCliente="$route.params.id" @fecharModal="fecharModal" />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssAreaInteresseClienteService from '@/services/vendas/cliente/abas/AssAreaInteresseClienteService';
import AreaInteresseModal from '@/components/vendas/cliente/modal/AreaInteresseModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        AreaInteresseModal,
    },
    data() {
        return {
            assAreaInteresseClienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'CLI_ASSAREAINTERESSECLIENTE'
            ),
            areaInteresseIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'CLI_AREAINTERESSE'
            ),
            assareainteressecliente: [],
            fields: [
                { key: 'codigo', width: 100, sortable: true, sortFn: null },
                {
                    key: 'cli-areainteresse',
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new AssAreaInteresseClienteService(this.$http, this.$router),
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacao: { id: 2, label: 'todos' },
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'cli-areainteresse',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            permissaoCadastroAreaInteresse: false,

            //permissoes relativas à exibição dos botões
            permissaoVincularECadastrar: false,
            permissaoVincular: false,
            permissaoCadastrar: false,

            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-dados-cadastrais-cli-areainteresse'
            );
        } else if (this.isAgro) {
            this.permissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-dados-cadastrais-cli-areainteresse'
            );
        }

        this.permissaoCadastroAreaInteresse = this.hasPermissionAccess(
            'agro',
            'agro-cadastros',
            'cli-areainteresse'
        );

        // variáveis que definem as permissões com base nas permissões da tela e dos dados que vêm do ERP
        this.permissaoVincularECadastrar =
            this.permissao.create &&
            !this.assAreaInteresseClienteIntegracao &&
            this.permissaoCadastroAreaInteresse.create &&
            !this.areaInteresseIntegracao;
        this.permissaoVincular =
            this.permissao.create &&
            !this.assAreaInteresseClienteIntegracao &&
            (!this.permissaoCadastroAreaInteresse.create || this.areaInteresseIntegracao);
        this.permissaoCadastrar =
            this.permissaoCadastroAreaInteresse.create &&
            !this.areaInteresseIntegracao &&
            (!this.permissao.create || this.assAreaInteresseClienteIntegracao);

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-cli-areainteresse-' + numberId;
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacao.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.assareainteressecliente = value;
                    this.isEmpty = this.assareainteressecliente.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as tabelas de preços.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, idcliente, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idassareainteressecliente: m.idassareainteressecliente,
                    codigo: m.idassareainteressecliente,
                    'cli-areainteresse': m.areainteresse.descricao,
                    situacao: m.situacao,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n',
                    { n: row['cli-areainteresse'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 3
                    ? 'msg-erro-ao-desativar-associacao-area-interesse'
                    : 'msg-erro-ao-reativar-associacao-area-interesse';

            let tempAssareainteressecliente = {
                idassareainteressecliente: this.delete.idassareainteressecliente,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.updateSituacao(tempAssareainteressecliente)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-associacao-area-interesse'
                                : 'msg-sucesso-ao-desativar-associacao-area-interesse';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(assareainteressecliente) {
            if (this.isVenda) return this.service.updateSituacaoVendas(assareainteressecliente);
            else return this.service.updateSituacaoAgro(assareainteressecliente);
        },
        showModalAreaInteresseNaoAssociados() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;

    .situacao-select {
        div {
            height: 40px;
        }
    }

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .situacao-select {
            width: 100%;
            padding-bottom: 0.8rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
